// This script watches the select elements for changes and updates the view to the correct localisation settings when changed.

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ), //Hidden input for language or currency
      select: this.querySelector("select"), // Select element for language or currency
      form: this.querySelector("form"), // Form element
    };

    // console.log('LocalizationForm initialized:', this.elements);

    // Add event listener for the select element
    if (this.elements.select) {
      this.elements.select.addEventListener(
        "change",
        this.onSelectChange.bind(this)
      );
    }
  }

  onSelectChange(event) {
    // console.log('Select option changed:', event.target.value);

    // Update the hidden input value based on the selected option
    if (this.elements.input) {
      this.elements.input.value = event.target.value;
      // console.log('Input value updated to:', this.elements.input.value);
    }

    // Submit the form to update the language or currency
    if (this.elements.form) {
      // console.log('Submitting form for updated selection');
      this.elements.form.submit();
    }
  }
}

customElements.define("localization-form", LocalizationForm);
